module.exports = __webpack_public_path__ + "img/history-avatar.440e13ca.svg";